import "../nadia/NadiaWorkspace.css";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar, BottomNav } from "./Nav";
import { NotificationBell } from "../nadia/NotificationBell";
import { CreditsWallet } from "../nadia/CreditsWallet";
import { AccountMenu } from "../nadia/AccountMenu";

export function AppLayout() {
  const { pathname } = useLocation();
  const isChat = pathname === "/app/nadia" || pathname === "/app/nadia/";
  return (
    <div className="nadia-shell fixed inset-0 h-[100dvh] min-h-0 flex flex-col overflow-hidden lg:pl-[88px]" data-testid="nadia-workspace-layout" data-layout="nadia-light" data-view={isChat ? "chat" : "page"}>
      <Sidebar compact />
      <header className="h-16 shrink-0 border-b border-white/5 bg-[#090D16]/90 flex items-center justify-between gap-2 px-3 sm:px-5 lg:px-6">
        <div className="nadia-brand"><span className="nadia-brand-mark">N</span><div><strong>Nadia Cloud</strong><small>Il tuo Direttore Marketing AI</small></div></div>
        <div className="flex items-center gap-1 sm:gap-2 shrink-0"><CreditsWallet /><NotificationBell /><AccountMenu /></div>
      </header>
      <main data-testid={isChat ? "chat-page-content" : "app-page-content"} className={isChat ? "flex flex-1 min-h-0 overflow-hidden px-3 sm:px-5 lg:px-6 pt-4 lg:pt-6 pb-24 lg:pb-5" : "flex-1 min-h-0 min-w-0 overflow-y-auto overscroll-contain px-4 sm:px-6 lg:px-8 pt-5 lg:pt-7 pb-24 lg:pb-8"}>
        {isChat ? <Outlet /> : <div className="w-full min-w-0 max-w-7xl mx-auto"><Outlet /></div>}
      </main>
      <BottomNav />
    </div>
  );
}
